import { FC } from "react";
import { useRecoilValue } from "recoil";

import {
  bulkJourneyAssignFormDrawerAF,
  bulkUpdateFormDrawerAF,
  reportBulkOperationsDrawerAF,
  ReportTemplateIdEnum,
  RideCrudModeKey,
} from "@ryde/shared";

import { BulkJourneyAssignFormRidesDrawer } from "../../rides";
import {
  BulkOperationsRidesReportDrawer,
  BulkUpdateFormForceEntityDrawer,
  RidesReportFloatingMenu,
} from "./shared";

export const ReportsRelatedEntitiesContentBulk: FC = () => {
  const rideEntity = RideCrudModeKey.uiUnit;

  const ridesReportBulkOperationsDrawerOpened = useRecoilValue(
    reportBulkOperationsDrawerAF(ReportTemplateIdEnum.RIDE_ANALYTICS_REPORT),
  );

  const bulkJourneyAssignFormDrawerOpened = useRecoilValue(
    bulkJourneyAssignFormDrawerAF(rideEntity),
  );

  const bulkRideUpdateFormDrawerOpened = useRecoilValue(
    bulkUpdateFormDrawerAF(rideEntity),
  );

  return (
    <>
      {ridesReportBulkOperationsDrawerOpened && (
        <BulkOperationsRidesReportDrawer />
      )}
      {bulkJourneyAssignFormDrawerOpened && (
        <BulkJourneyAssignFormRidesDrawer />
      )}
      {bulkRideUpdateFormDrawerOpened && (
        <BulkUpdateFormForceEntityDrawer forceEntity={rideEntity} />
      )}
      <RidesReportFloatingMenu />;
    </>
  );
};
